// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"01960030","299":"82fcbdbd","453":"61374863","478":"65c687bc","653":"3864c7c7"}[chunkId] + ".chunk.js";
};